import { Dispatch, Action } from 'redux'
import { ReplyMessageCardMapDispatchReturnType } from './types/ReplyMessageCardMapDispatchReturnType'

export const ReplyMessageCardMapDispatch = (
  _dispatch: Dispatch<Action>
): ReplyMessageCardMapDispatchReturnType => {
  return {}
}
